import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0506b8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "dropdown__header" }
const _hoisted_3 = { class: "dropdown__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0 1.73798L0.874823 0.916584L4.98178 5.2907L4.10696 6.11209L0 1.73798Z",
  fill: "black"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M4.10696 6.11209L3.28557 5.23727L7.65968 1.13031L8.48107 2.00513L4.10696 6.11209Z",
  fill: "black"
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["indeterminate"]
const _hoisted_8 = { class: "dropdown__title-text" }
const _hoisted_9 = { style: {"min-height":"0","position":"relative"} }

import { ref, toRefs, watch } from 'vue';
import { SettingsStore, useSettingsStore } from '@/store/settings';
import MyBtn from '../MyBtn.vue';

interface IDropDownProps {
  title: string;
  index: number;
  checkboxed?: boolean;
  withMixButton?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropDown',
  props: {
    title: {},
    index: {},
    checkboxed: { type: Boolean },
    withMixButton: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const settingsStore: SettingsStore = useSettingsStore();
const { changeAllVisibility, changeMix, settings } = settingsStore;


const { title, index, checkboxed = false, withMixButton = false } = toRefs(props);

const allCheckBox = ref(false);
const isActive = ref(false);
const toMix = ref(false);
const isSomeItemActive = ref(false);
const onDropdownClick = (e: MouseEvent) => {
  // Проверка нажатия на div или span, для того чтобы механизм dropdown
  // не открывался при нажатии на checkbox или кнопку
  if (!(e.target instanceof HTMLInputElement || e.target instanceof HTMLButtonElement)) {
    isActive.value = !isActive.value;
  }
};

watch(settings[index.value], () => {
  const optionsOnVisible = settings[index.value].filter((option) => option.visibility);
  if (optionsOnVisible.length > 0 && optionsOnVisible.length < settings[index.value].length) {
    isSomeItemActive.value = true;
  } else if (optionsOnVisible.length === settings[index.value].length) {
    isSomeItemActive.value = false;
    allCheckBox.value = true;
  } else {
    isSomeItemActive.value = false;
    allCheckBox.value = false;
  }
});

watch(allCheckBox, () => {
  changeAllVisibility(index.value, allCheckBox.value);
});

const onMixClick = () => {
  toMix.value = !toMix.value;
  changeMix(index.value, toMix.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "dropdown",
      onClick: _cache[1] || (_cache[1] = (e) => onDropdownClick(e))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(isActive.value || isSomeItemActive.value || allCheckBox.value ? '_active' : null),
            xmlns: "http://www.w3.org/2000/svg",
            width: "9",
            height: "7",
            viewBox: "0 0 9 7",
            fill: "none"
          }, _hoisted_6, 2)),
          (_unref(checkboxed))
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((allCheckBox).value = $event)),
                indeterminate: isSomeItemActive.value
              }, null, 8, _hoisted_7)), [
                [_vModelCheckbox, allCheckBox.value]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(title)), 1)
        ]),
        ((isSomeItemActive.value || allCheckBox.value) && _unref(withMixButton))
          ? (_openBlock(), _createBlock(MyBtn, {
              key: 0,
              title: toMix.value ? 'Сортировать' : 'Перемешать',
              "on-btn-click": onMixClick
            }, null, 8, ["title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(
        isActive.value || isSomeItemActive.value || allCheckBox.value
          ? 'dropdown__content _active'
          : 'dropdown__content'
      )
    }, [
      _createElementVNode("div", _hoisted_9, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 2)
  ]))
}
}

})